import React, { Component } from 'react';
import autobind from 'class-autobind';

import isEqual from 'lodash/isEqual';

import VideoishPlayer from 'zoomforth_component_lib/videoish_player.jsx';

import {
  makeVideoishPlayerPropsForContent
} from 'zoomforth_tools/videoish_player.js';

import SiteViewerVersionComponentSelector
  from 'zoomforth_codesbane_viewer/component_lib/site_viewer_version_component_selector_container.jsx';

class SlideshowVideoItemUi_ViewerVersion1  extends Component {

  constructor(props) {
    super(props);

    this.videoPlayer = null;

    autobind(this);
  }

  shouldComponentUpdate(nextProps) {
    // ensure we stop the previously playing video if the slide changes
    // is this the right place for this? no. but...it works so there's that.
    if (this.props.currentSlideIdx !== nextProps.currentSlideIdx) {
      if (this.videoPlayer && this.videoPlayer._player) {
        this.props.onSetVideoPlaying(false);
        this.videoPlayer._player.pause();
      }
    }

    // when using the editor, we set the viewer's selected content but we do
    // not want to embed and render this component again.
    if (!isEqual(this.props.contentItem, nextProps.contentItem)) {
      return true;
    }
    return false;
  }

  componentWillUnmount() {
    this.videoPlayer = null;
    this.props.onSetVideoPlaying(false);
  }

  render() {
    const {
      asset,
      contentItem,
      onSetVideoPlaying,
      onPause,
      onPlay,
      onStart,
      ...props
    } = this.props;

    const videoishPlayerProps = makeVideoishPlayerPropsForContent(contentItem, asset);
    const { id, posterImageUrl } = videoishPlayerProps;

    // Generate a unique key based on the posterImageUrl. The idea here is that
    // changing the poster image should force the video player to update. The
    // problem is the VideoishPlayer doesn't support updates due to the way we
    // instantiate VideoJS. This means it's the parent's responsibility to
    // mount / unmount the component and the best means of doing that is
    // through React keys. A changed key means the whole thing remounts.
    const uniqueKey = `${id}-${posterImageUrl}`;

    return (
      <div key={uniqueKey} className="galleria-image-wrapper">
        <VideoishPlayer
          { ...videoishPlayerProps }
          {...props}
          getVideoPlayer={(ref)=> this.videoPlayer = ref}
          onPause={(videoEventData)=> { 
            onSetVideoPlaying(false); 
            onPause(videoEventData); 
          }}
          onPlay={(videoEventData)=> { 
            onSetVideoPlaying(true); 
            onPlay(videoEventData); 
          }}
          onStart={(videoEventData)=> { 
            onSetVideoPlaying(true); 
            onStart(videoEventData); 
          }}
        />
      </div>
    );
  }

}

class SlideshowVideoItemUi_ViewerVersion2  extends Component {

  constructor(props) {
    super(props);

    this.videoPlayer = null;

    autobind(this);
  }

  shouldComponentUpdate(nextProps) {
    // ensure we stop the previously playing video if the slide changes
    // is this the right place for this? no. but...it works so there's that.
    if (this.props.currentSlideIdx !== nextProps.currentSlideIdx) {
      if (this.videoPlayer && this.videoPlayer._player) {
        this.props.onSetVideoPlaying(false);
        this.videoPlayer._player.pause();
      }
    }

    // when using the editor, we set the viewer's selected content but we do
    // not want to embed and render this component again.
    if (!isEqual(this.props.contentItem, nextProps.contentItem)) {
      return true;
    }
    return false;
  }

  componentWillUnmount() {
    this.props.onSetVideoPlaying(false);

    this.videoPlayer = null;
  }

  render() {
    const {
      asset,
      contentItem,
      onSetVideoPlaying,
      onPause,
      onPlay,
      onStart,
      ...props
    } = this.props;

    const videoishPlayerProps = makeVideoishPlayerPropsForContent(contentItem, asset);
    const { id, posterImageUrl } = videoishPlayerProps;

    // Generate a unique key based on the posterImageUrl. The idea here is that
    // changing the poster image should force the video player to update. The
    // problem is the VideoishPlayer doesn't support updates due to the way we
    // instantiate VideoJS. This means it's the parent's responsibility to
    // mount / unmount the component and the best means of doing that is
    // through React keys. A changed key means the whole thing remounts.
    const uniqueKey = `${id}-${posterImageUrl}`;

    return (
      <div key={uniqueKey} style={{ height: '100%', width: '100%' }}>
        <VideoishPlayer
          { ...videoishPlayerProps }
          {...props}
          getVideoPlayer={(ref)=> this.videoPlayer = ref}
          onPause={(videoEventData)=> { 
            onSetVideoPlaying(false); 
            onPause(videoEventData); 
          }}
          onPlay={(videoEventData)=> { 
            onSetVideoPlaying(true); 
            onPlay(videoEventData); 
          }}
          onStart={(videoEventData)=> { 
            onSetVideoPlaying(true); 
            onStart(videoEventData); 
          }}
        />
      </div>
    );
  }

}

const SlideshowVideoItem = (props)=> (
  <SiteViewerVersionComponentSelector>
    <SlideshowVideoItemUi_ViewerVersion1 forSiteViewerVersion={1} { ...props } />
    <SlideshowVideoItemUi_ViewerVersion2 forSiteViewerVersion={2} { ...props } />
  </SiteViewerVersionComponentSelector>
);

export default SlideshowVideoItem;
